"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _NavMenu = require("../NavMenu/");

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  menu: {
    position: "absolute",
    zIndex: 1,
    top: 0,
    right: "auto",
    left: 0,
    bottom: 0,
    width: props => {
      return props.menuWidth;
    },
    marginLeft: props => {
      return "-" + props.menuWidth;
    },
    transition: ".125s ease-out",
    "&[aria-expanded=true]": {
      marginLeft: 0
    },
    "&[aria-expanded=true] + *": {
      marginLeft: props => {
        return props.menuWidth;
      }
    }
  },
  menuList: {
    margin: theme.spacing(3),
    "& > li + li": {
      marginTop: theme.spacing(1)
    }
  }
}));

const PageMenu = ({
  menuWidth = 224,
  menu = undefined
}) => {
  const classes = useStyles({
    menuWidth
  });

  if (!menu) {
    return false;
  }

  return _react.default.createElement("aside", {
    className: classes.menu,
    "aria-expanded": true
  }, _react.default.createElement(_NavMenu.MenuList, {
    className: classes.menuList
  }, menu.map((item, index) => {
    return _react.default.createElement(_NavMenu.MenuItem, null, _react.default.createElement(_NavMenu.MenuLink, item));
  })));
};

var _default = PageMenu;
exports.default = _default;
module.exports = exports.default;